import {Injectable} from '@angular/core'

/**
 * Mock Deploy class for web/browser environments
 * Cordova plugin Deploy is only available on native platforms
 */
@Injectable({
  providedIn: 'root',
})
export class DeployMock {
  sync(options?: any): Promise<void> {
    return Promise.resolve()
  }

  getConfiguration(): Promise<any> {
    return Promise.resolve({})
  }

  configure(config?: any): Promise<void> {
    return Promise.resolve()
  }

  fetch(): Promise<void> {
    return Promise.resolve()
  }

  reload(): Promise<void> {
    return Promise.resolve()
  }

  getVersions(): Promise<any> {
    return Promise.resolve({current: '', available: ''})
  }

  info(): Promise<any> {
    return Promise.resolve({label: '', binary: '', uuid: ''})
  }
}
